import React from 'react'
import {connect} from "react-redux";
import LoadingScreen from "./LoadingScreen";

function HookLoadingScreen(
    {
        loadingScreen
    }) {
    return !!loadingScreen && <LoadingScreen/>
}

export default connect((state) => ({
    loadingScreen: state.store.loadingScreen
}))(HookLoadingScreen);